import { businessConnectionMst, mstCommon } from '@libs/domain';
import { Characters, Item } from '@ps-smart-cp/ppfw-client';
import { useMstSettings } from '../../../context';

export function useBusinessConnectionItems() {
  const { businessConnection } = useMstSettings();
  const attr = Characters.preset.halfWidth({
    minLen: +businessConnection.codeDigits,
    maxLen: +businessConnection.codeDigits,
    required: true,
  });

  return {
    code: Item.of(mstCommon.names.code, attr),
    supplierCode: Item.of(businessConnectionMst.names.supplier, attr.replaceRequired(false)),
    lentPartyCode: Item.of(businessConnectionMst.names.lentParty, attr.replaceRequired(false)),
  };
}
